import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a short delay for better UX
      setTimeout(() => {
        setShowBanner(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    // You can add analytics/tracking initialization here
    console.log('Cookies accepted');
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
    console.log('Cookies declined');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-slide-up">
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-2xl border-2 border-accent-primary/20">
        <div className="p-6 md:p-8">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-dark mb-2">🍪 Cookie Notice</h3>
              <p className="text-gray-600 mb-4">
                We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
                By clicking "Accept", you consent to our use of cookies. You can manage your preferences or learn 
                more in our{' '}
                <a 
                  href="/privacy" 
                  className="text-accent-primary hover:underline font-semibold"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>.
              </p>
            </div>
            <button
              onClick={handleDecline}
              className="ml-4 text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Close"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={handleAccept}
              className="bg-accent-primary hover:bg-accent-primary/90 font-bold px-8 py-3 text-base flex-1 sm:flex-none rounded-md transition-colors"
              style={{ color: 'white' }}
            >
              ✓ Accept Cookies
            </button>
            <button
              onClick={handleDecline}
              className="border-2 border-gray-300 text-gray-700 hover:bg-gray-100 px-8 py-3 text-base font-semibold flex-1 sm:flex-none rounded-md bg-white transition-colors"
            >
              ✗ Decline
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
